/* nc-footer */
(function(){
  function brand(){
    var links=document.querySelector('#shopify-section-footer .nc-foot-links');
    if(!links || document.querySelector('#shopify-section-footer .nc-foot-brand')) return;
    var b=document.createElement('div'); b.className='nc-foot-brand';
    var lock=document.createElement('div'); lock.className='nc-foot-lock';
    var dl=document.querySelector('#cart img.nc-dlogo');
    if(dl){ var chip=document.createElement('span'); chip.className='nc-foot-chip'; var img=dl.cloneNode(true); img.removeAttribute('loading'); img.removeAttribute('width'); img.removeAttribute('height'); img.className='nc-foot-emblem'; chip.appendChild(img); lock.appendChild(chip); }
    var w=document.createElement('div'); w.className='nc-foot-word'; w.innerHTML='NORTH&nbsp;COVE<small>WELLNESS &amp; CARE</small>'; lock.appendChild(w);
    b.appendChild(lock);
    var t=document.createElement('p'); t.className='nc-foot-tag'; t.textContent='Drug-free relief, recovery, and sleep tools — made for everyday life.'; b.appendChild(t);
    links.insertBefore(b, links.firstChild);
  }
  /* MOBILE ONLY: reorder footer to match the reference structure — logo/brand on top, then contact, then newsletter, then the menu columns. Desktop is left untouched. */
  function mobileOrder(){
    var f=document.querySelector('#shopify-section-footer'); if(!f) return;
    var brandEl=f.querySelector('.nc-foot-brand');
    var links=f.querySelector('.nc-foot-links');
    var colBlock=null,newsB=null,contactB=null;
    [].slice.call(f.children).forEach(function(b){
      if(b===brandEl) return;
      if(b.querySelector && b.querySelector('.nc-foot-links')) colBlock=b;
      else if(b.querySelector && b.querySelector('#newsletter-footer')) newsB=b;
      else if(/contact|support|email us/i.test(b.textContent||'')) contactB=b;
    });
    var mobile=window.matchMedia('(max-width:760px)').matches;
    if(mobile){
      if(brandEl && brandEl.parentNode!==f) f.insertBefore(brandEl, f.firstChild);
      if(brandEl) brandEl.style.order='0';
      if(contactB) contactB.style.order='1';
      if(newsB) newsB.style.order='2';
      if(colBlock) colBlock.style.order='3';
    } else {
      if(brandEl && links && brandEl.parentNode===f) links.insertBefore(brandEl, links.firstChild);
      [brandEl,contactB,newsB,colBlock].forEach(function(el){ if(el) el.style.order=''; });
    }
  }
  function run(){ try{brand();}catch(e){} try{mobileOrder();}catch(e){} }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  window.addEventListener('resize',function(){ try{mobileOrder();}catch(e){} });
  setTimeout(run,700); setTimeout(run,1600);
})();
